import { render } from "./GitpleButton.vue?vue&type=template&id=7c15546f"
import script from "./GitpleButton.vue?vue&type=script&lang=js"
export * from "./GitpleButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__